import React from "react";
import { Helmet } from "react-helmet-async";
import { Box, Stack } from "@mui/material";

import CachedIcon from "@mui/icons-material/Cached";

import LogList from "./component/T_Log";

import useLog from "../../../hooks/super/useLog";
import useAuth from "../../../hooks/useAuth";
import { CollapseAlert } from "../../../components/pages/common/styled";
import PageHeader from "../../../components/pages/_new/super/common/PageHeader";
import OutlinedButton from "../../../components/pages/_new/super/common/OutlinedButton";

function SALog() {
  const { isAuthenticated } = useAuth();
  const { getLogs, size, errMsg, setErr } = useLog();

  React.useEffect(() => {
    if (isAuthenticated) getLogs(size, 0);
    return () => setErr(null);
  }, [isAuthenticated, size, getLogs, setErr]);

  const refresh = async () => {
    getLogs(size, 0);
  };
  const [errOpen, setErrOpen] = React.useState(false);
  React.useEffect(() => {
    setErrOpen(true);
  }, [errMsg]);

  return (
    <React.Fragment>
      <Helmet title="SA Audit Log" />
      <PageHeader
        title="Audit Log"
        description="View system audit logs and activity history"
        actions={
          <OutlinedButton
            onClick={refresh}
            startIcon={<CachedIcon style={{ width: 20, height: 20 }} />}
          >
            Refresh
          </OutlinedButton>
        }
      />
      <Box sx={{ mb: 4 }}>
        <CollapseAlert errOpen={errOpen} setErrOpen={setErrOpen} setErr={setErr} errMsg={errMsg} />
      </Box>
      <Stack spacing={4}>
        <LogList />
      </Stack>
    </React.Fragment>
  );
}
export default SALog;
